import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-newline',
    templateUrl: './newline.component.html',
    styleUrls: ['./newline.component.css'],
    standalone: false
})
export class NewlineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

